(function () {
  var EDIT_ICON =
    '<svg class="wss-gpo-edit__icon" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false">' +
    '<path d="M14.85 2.85a1.5 1.5 0 0 1 2.12 0l1.18 1.18a1.5 1.5 0 0 1 0 2.12L7.4 16.9l-4 1 1-4L14.85 2.85Z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var forcedOpen = new Set();
  var refreshQueued = false;

  function fieldId(el) {
    return el.getAttribute("data-element-id") || "";
  }

  function isCandidateType(el) {
    return !!el.querySelector(
      'input[type="radio"]:not(:disabled), input[type="checkbox"]:not(:disabled), ' +
        "select:not(:disabled), textarea:not(:disabled), " +
        'input[type="text"]:not(:disabled), input[type="number"]:not(:disabled), ' +
        'input[type="email"]:not(:disabled), input[type="file"]:not(:disabled)'
    );
  }

  function isExcluded(el) {
    var id = fieldId(el);
    if (id.indexOf("divider") === 0) return true;
    if (el.classList.contains("final-img-holder")) return true;
    if (getComputedStyle(el).display === "none") return true;
    // a wrapper around a nested sub-group, not a leaf question itself
    if (el.querySelector(".gpo-group__childs")) return true;
    return false;
  }

  function isAnswered(el) {
    var radios = el.querySelectorAll('input[type="radio"]');
    if (radios.length) {
      return Array.prototype.some.call(radios, function (r) {
        return r.checked;
      });
    }
    var checkboxes = el.querySelectorAll('input[type="checkbox"]');
    if (checkboxes.length) {
      return Array.prototype.some.call(checkboxes, function (c) {
        return c.checked;
      });
    }
    var select = el.querySelector("select");
    if (select) return select.value.trim() !== "";

    var file = el.querySelector('input[type="file"]');
    if (file) return file.files && file.files.length > 0;

    var textField = el.querySelector(
      'input[type="text"], input[type="number"], input[type="email"], textarea'
    );
    if (textField) return textField.value.trim() !== "";

    return false;
  }

  function ensureEditButton(el) {
    if (el.querySelector(".wss-gpo-edit")) return;
    var anchor = el.querySelector(".gpo-selected-values") || el.querySelector(".gpo-label");
    if (!anchor) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "wss-gpo-edit";
    btn.setAttribute("aria-label", "Редагувати вибір");
    btn.innerHTML = EDIT_ICON;
    btn.addEventListener("click", function (event) {
      event.preventDefault();
      forcedOpen.add(fieldId(el));
      refreshCascade();
    });

    anchor.insertAdjacentElement("afterend", btn);
  }

  function setState(el, state) {
    var current = el.className.match(/wss-gpo-step--\w+/);
    if (!current || current[0] !== state) {
      el.classList.remove(
        "wss-gpo-step--pending",
        "wss-gpo-step--active",
        "wss-gpo-step--done"
      );
      el.classList.add(state);
    }
  }

  function collectCandidates(root) {
    var candidates = [];
    var els = root.querySelectorAll(".gpo-group__childs > .gpo-element");

    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (isExcluded(el)) continue;
      if (!isCandidateType(el)) continue;
      candidates.push(el);
    }

    return candidates;
  }

  function refreshCascade() {
    var forms = document.querySelectorAll(".gpo-container");

    forms.forEach(function (form) {
      var candidates = collectCandidates(form);
      var reachedActive = false;

      candidates.forEach(function (el) {
        var id = fieldId(el);
        var answered = isAnswered(el);

        if (!answered && forcedOpen.has(id)) forcedOpen.delete(id);

        if (reachedActive) {
          setState(el, "wss-gpo-step--pending");
          return;
        }

        if (!answered) {
          setState(el, "wss-gpo-step--active");
          reachedActive = true;
          return;
        }

        if (forcedOpen.has(id)) {
          setState(el, "wss-gpo-step--active");
          return;
        }

        setState(el, "wss-gpo-step--done");
        ensureEditButton(el);
      });
    });
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    setTimeout(function () {
      refreshQueued = false;
      refreshCascade();
    }, 50);
  }

  function findOptionInput(target) {
    var wrapper = target.closest(".gpo-swatches, .gpo-ov-item");
    if (wrapper) return wrapper.querySelector('input[type="radio"]');

    var label = target.closest("label");
    if (label) {
      var forId = label.getAttribute("for");
      return forId
        ? document.getElementById(forId)
        : label.querySelector('input[type="radio"]');
    }

    return target.tagName === "INPUT" ? target : null;
  }

  function onOptionMousedown(event) {
    if (!event.target.closest(".gpo-container")) return;

    var input = findOptionInput(event.target);
    if (input && input.type === "radio") {
      input.dataset.wssWasChecked = input.checked ? "1" : "";
    }
  }

  function onOptionClick(event) {
    if (!event.target.closest(".gpo-container")) return;

    var input = findOptionInput(event.target);
    if (input && input.type === "radio" && input.dataset.wssWasChecked === "1") {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var el = input.closest(".gpo-element");
      if (el) {
        forcedOpen.delete(fieldId(el));
        refreshCascade();
      }
    }
  }

  function onFieldChange(event) {
    var form = event.target.closest(".gpo-container");
    if (!form) return;

    var input = event.target;
    var el = input.closest(".gpo-element");

    if (input.tagName === "INPUT" && input.type === "radio" && !input.checked) {
      if (el && !isAnswered(el)) {
        input.checked = true;
        refreshCascade();
        return;
      }
    }

    if (el) forcedOpen.delete(fieldId(el));

    refreshCascade();
  }

  function observeForms() {
    document.querySelectorAll(".gpo-container").forEach(function (form) {
      if (form.dataset.wssCascadeObserved) return;
      form.dataset.wssCascadeObserved = "true";

      var observer = new MutationObserver(queueRefresh);
      observer.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "data-clo-display"],
      });
    });
  }

  function init() {
    if (document.querySelectorAll(".gpo-element").length === 0) {
      setTimeout(init, 500);
      return;
    }

    observeForms();
    refreshCascade();
  }
  
  document.addEventListener("mousedown", onOptionMousedown, true);
  document.addEventListener("click", onOptionClick, true);
  document.addEventListener("change", onFieldChange, true);
  document.addEventListener("gpoRenderCompleted", function () {
    observeForms();
    refreshCascade();
  });
  document.addEventListener("DOMContentLoaded", init);
})();
